import React from 'react';
import './App.scss';
import Hero from './Hero/Hero';
import Footer from './common-footer/Footer';
import Header from './common-header/Header';
import inline1 from '../assets/inline1.png';
import inline2 from '../assets/inline2.png';
import inline3 from '../assets/inline3.png';
import Quotes from './Quotes/Quotes';
import cta3 from '../assets/cta3.png';
import cta1 from '../assets/cta1.png';

function App() {
  const quotesContent = {
    quote1:
      '5G mobile brings the same class of performance as a fixed, wired network in terms of throughput capacity, responsiveness, and latency. As a result, companies may move away from wired networks altogether, and we may see everything become wireless.”',
    quote2:
      'There are times when you want to be at the edge, there are times when you need to be at the edge, and now 5G and Supermicro’s Intel-powered servers give you the capability to do more at the edge. It all works together as a virtuous circle.”',
    quote3:
      'The breadth of Supermicro’s product line allows us to offer a range of devices that are well-suited to each application.”',
    quote4:
      '5G plus edge computing will finally allow us to finally realize the promise of virtual reality (VR) and augmented reality (AR), because those are both very dependent on low latency.”'
  };
  return (
    <main className="App">
      <Header clientName={"Supermicro & Intel"}/>
      <Hero />
      <div className="copy copy1">
        <p className="copy__copy copy__copy1">
          <span className="copy__title copy__title1">
            5G is already starting to fuel digital transformations.
          </span>{' '}
          Soon, companies will have even more 5G-related capabilities at their fingertips as
          upcoming 5G releases introduce new features such as micropositioning and device-to-device
          communications.
        </p>
        <img src={inline1} alt="Portrait of Michael Clegg" className="inline1" />
        <p className="copy__copy">
          As a global technology leader, Supermicro produces the end-to-end solutions that power{' '}
          <a
            className="copy--blue"
            href="https://www.supermicro.com/en/products/5g"
            target="_blank"
            rel="sponsored"
          >
            next-gen 5G networks
          </a>
          . Here, Supermicro’s VP and GM of 5G and Embedded/IoT, Michael Clegg, offers his insights
          on how 5G and edge computing could enable transformative change all the way from the
          network core to the furthest edge.
        </p>
        <p className="copy__title copy__copy3">What are some of the key benefits that 5G offers?</p>
        <p className="copy__copy">There are three main benefits associated with 5G:</p>
        <p className="copy__copy">
          <span className="copy__title">Speed.</span> 5G offers enhanced mobile broadband speeds,
          which I would call a faster form of 4G communications.
        </p>
        <p className="copy__copy">
          <span className="copy__title">Connectivity.</span> 5G has greater capacity to handle a
          massive volume of machine communications among numerous sensor devices without dragging
          down the bulk of the network communications.
        </p>
        <p className="copy__copy">
          <span className="copy__title">Low latency.</span> Fast response times are essential in
          many applications. For example, if you want to have autonomous cars, those vehicles need
          to know whether a traffic light has changed before they reach an intersection! 5G is the
          first network that has been designed to offer extremely low latency, which is key to
          enabling real-time automation.
        </p>
        <Quotes quotesContent={quotesContent.quote1} />
        <p className="copy__title">What advantages does 5G offer at the enterprise level?</p>
        <p className="copy__copy">
          Historically, mobile networks have not offered the same level of performance as either
          Wi-Fi or fixed networks. 5G mobile brings the same class of performance as a fixed, wired
          network in terms of throughput capacity, responsiveness, and latency. As a result,
          companies may move away from wired networks altogether, and we may see everything become
          wireless. In an industrial setting, going totally wireless would allow factories to be
          much more dynamic and flexible in terms of reconfiguring layout to optimize production.
        </p>
        <p className="copy__copy">
          Beyond the speed and connectivity advantages, 5G also offers enterprises security
          benefits. With Wi-Fi networks, companies are relying on passwords or some other kind of
          code. On a 5G network, users register using the SIM cards on their mobile devices, which
          gives network administrators the ability to verify identities and prevent unauthorized
          users from registering or connecting to the network. That’s how 5G brings the benefits of
          mobile security into the enterprise environment.
        </p>
        <p className="copy__copy">
          5G also has native abilities to create private networks using unlicensed spectrum in the
          CBRS [Citizens Broadband Radio Service] band. Previously, these capabilities were only
          available as add-ons to 4G LTE networks. You’re starting to see companies using 5G to
          deploy their own private networks in settings such as smart factories, ports, and harbors.
        </p>
        <p className="copy__copy">
          From a deployment point of view, private 5G networks behave like Wi-Fi and become an
          extension of corporate IT infrastructure. These 5G networks offer advantages over Wi-Fi in
          high-mobility use cases. For example, autonomous robots moving on a factory floor or
          drones flying around an oil field would have trouble operating safely using Wi-Fi because
          they would experience latency problems with dropped connections as they moved between
          Wi-Fi access points. 5G private networks coupled with edge computing can solve that
          problem and enable greater mobile connectivity on corporate campuses.
        </p>
      </div>
      <div className="copy__inline">
        <img src={inline2} className="inline2" alt="server" />
        <p className="copy__caption">Supermicro Outdoor Edge Server</p>
      </div>
      <div className="copy">
        <p className="copy__title">What is the connection between 5G and edge computing?</p>
        <p className="copy__copy">
          To take advantage of 5G’s low latency capabilities, you need a backbone network that also
          offers low latency, and the way to reduce latency is to bring computing closer to the edge
          of the network.
        </p>
        <p className="copy__copy">
          Consider applications such as mobile gaming or the new sport of drone racing. Having fast
          5G capabilities on your mobile device or on your drone does not offer much benefit if you
          experience excessive lag times while data travels back and forth to the network core. To
          get the instantaneous response times you need in order to prevent your quarterback from
          getting sacked or your drone from slamming into an obstacle, the best solution is to move
          the computing processes right out to the edge.
        </p>
        <Quotes quotesContent={quotesContent.quote2} />
      </div>
      <div className="copy copy__margin">
        <p className="copy__title">
          What sort of technical infrastructure do companies need to capitalize on the potential of
          5G and edge computing?
        </p>
        <p className="copy__copy">
          To get the benefits of 5G and edge computing, the only physical things you need are radios
          and Supermicro servers featuring 3rd Gen Intel® Xeon® Scalable Processors. Incidentally,
          these are the same type of servers that you would use in a data center, which means your
          IT managers will already know how to fire the server up, run it, manage it, and interact
          with it. From a provisioning, purchasing, and deployment point of view, it looks like a
          standard piece of IT equipment. You can literally use the same server either on the 5G
          side or put it in your data center and run a database on it.
        </p>
        <p className="copy__copy">
          With earlier generations of wireless technology, you needed a proprietary base station,
          but because 5G is cloud-native, the software has been virtualized to run that software on
          a server.
        </p>
        <p className="copy__copy">
          We're now making our{' '}
          <a
            className="copy--blue"
            href="https://www.supermicro.com/en/products/x12?utm_source=CNN&utm_medium=Article%201&utm_campaign=X12%20PostLaunch"
            target="_blank"
            rel="sponsored"
          >
            Supermicro X12 servers
          </a>{' '}
          that incorporate 3rd Gen Intel® Xeon® Scalable processors—which enables easier, faster
          workload and service deployments, using ecosystem solutions supported by an unmatched
          portfolio. With every generation, these servers get more powerful and better at running
          virtual applications. They also add instruction sets that reduce the amount of computing
          required for communications, which frees up the server to do other types of work.
        </p>
      </div>
      <div className="copy">
        <p className="copy__title">
          How can Supermicro’s products and services help companies realize the benefits of 5G and
          edge computing?
        </p>
        <p className="copy__copy">
          Data centers are normally nice environments with controlled temperatures and good power,
          but a select group of Supermicro servers and systems are{' '}
          <a
            className="copy--blue"
            href="https://www.youtube.com/watch?v=CM47nathiw8"
            target="_blank"
            rel="sponsored"
          >
            designed to excel in less controlled and less predictable edge environments
          </a>
          .
        </p>
        <p className="copy__copy">
          It’s also usually the case that companies have fewer resources to maintain servers at the
          edge. You don’t want to do a truck roll every time you need to update or check something
          on an edge device, so remote management becomes particularly critical. That’s an area
          where we have been working a lot recently with some of our partners.
        </p>
        <p className="copy__copy">
          The breadth of Supermicro’s product line allows us to offer a range of devices that are
          well-suited to each application. For applications close to the edge, we have low-power
          devices with a small footprint running Atom processors. As you get closer to the core and
          want more processing power, we have Xeon-class servers that are designed for industrial
          applications. We also use those Xeon-powered servers in 5G radio access network
          applications.
        </p>
        <Quotes quotesContent={quotesContent.quote3} />
      </div>

      <div className="copy copy__margin">
        <p className="copy__title">
          What is the full potential impact of 5G and edge computing for industry?
        </p>
        <p className="copy__copy">
          Industry 4.0 is tied to digital transformation, which involves taking existing production
          plants and automating them to improve efficiency. To have automation, you need to be able
          to track and monitor equipment and production flows. It’s not practical to run a wire to
          put a sensor on every device you want to measure, but 5G’s ability to handle a huge number
          of sensors—up to 1 million connected devices per square kilometer—lets you achieve this
          level of visibility wirelessly.
        </p>
        <p className="copy__copy">
          Industry 4.0 also involves AI and vision processing, both of which require a lot of
          computing power and bandwidth. 5G and edge computing allow you to feed visual data from a
          sensor on a conveyor belt into an AI system at the edge, process the data, and produce a
          result quickly enough for a robot to remove a faulty product from the production line.
        </p>
        <p className="copy__copy">
          Supermicro processors have a lot of I/O expansion cards, particularly around PCIe
          (peripheral component interconnect express), so we can put GPU cards in there, dedicated
          5G accelerators, or AI-specific cards to handle the video, AI, and machine learning
          applications at the edge. This gives companies the ability to personalize and modify the
          hardware for different applications and computing tasks.
        </p>
        <p className="copy__copy">
          5G and edge will also have a big impact in the power industry where assets are often
          physically distributed over a large area. With 5G, you can have drones running along power
          lines in fire-prone regions to check for nearby tree limbs and identify potential fire
          risk hazards. Today, people have to walk those power lines on foot or drive alongside them
          in a truck, but it would be much easier and faster to do that with a drone equipped with
          an AI vision system sending the data to a server at the edge for real-time processing.
        </p>
      </div>
      <div className="copy__inline">
        <img src={inline3} className="inline3" alt="" />
      </div>
      <div className="copy">
        <p className="copy__title">
          Do you see 5G as revolutionary technology or is it an evolutionary step forward from 4G?
        </p>
        <p className="copy__copy">
          In the short-term, 5G’s impact will be evolutionary, but I think we will see revolutionary
          applications five or ten years down the road. For instance, future releases of 5G will
          have micropositioning capabilities to determine the location of an object on a network
          down to the millimeter level. They will also bring sidelink capabilities that allow
          devices to ‘talk’ to each other without going through a central network hub.
        </p>
        <p className="copy__copy">
          Such capabilities will enable communication among autonomous vehicles, such as the drones
          that companies are starting to use for deliveries of medical supplies and other items. You
          need to have coordination and communication among these drones to prevent them from
          crashing into each other.
        </p>
        <p className="copy__copy">
          I also think 5G plus edge computing will finally allow us to realize the promise of
          virtual reality (VR) and augmented reality (AR), because those are both very dependent on
          low latency. In the early instances of VR, people got nauseous because there was a lag
          time between where they were looking and what they were seeing. 5G offers the low latency
          that will allow these applications to function as intended.
        </p>
        <Quotes quotesContent={quotesContent.quote4} />
        <p className="copy__title">
          {' '}
          With 5G and edge computing, does it feel like we’re poised to enter a new golden age of
          connectivity?
        </p>
        <p className="copy__copy">
          I would say that we have already entered this golden age of connectivity. Imagine how much
          more challenging it would have been to cope with the pandemic without high-speed broadband
          and Wi-Fi. Over the past couple of years, we have demonstrated the benefits of pervasive
          connectivity and proved that we can do all sorts of work remotely.
        </p>
        <p className="copy__copy">
          Now the goal is to extend that connectivity into the mobility space and start connecting
          autonomous devices. I also think we will see a focus on increasing the scope and quality
          of mobile network coverage in more rural areas. And 5G will play a pretty big role in
          that.{' '}
        </p>
        <p className="copy__copy">
          I do think you will see more people use augmented reality for training purposes. In
          healthcare situations, for example, physicians could access an AR overlay to prepare for
          an operation or even to perform remote telerobotic surgery. Some ambulances in the UK have
          already been provisioned with 5G so that doctors can work remotely with EMTs to perform
          triage before the patient arrives at the hospital.{' '}
        </p>
      </div>
      <div className="copy copy__last">
        <p className="copy__title">
          Would you like to share any blue-sky predictions for ways that technologies like 5G and
          edge computing might improve our lives in the future?
        </p>
        <p className="copy__copy">
          I’m not sure if it will happen in my lifetime, but I expect that my daughter or my
          grandkids won’t be driving, they will be traveling in personal flying vehicles. They will
          walk into the driveway, get into a drone, and take off. We’re going to need a lot of new
          communications infrastructure to handle air-traffic control for millions of autonomous
          flying personal aircraft!
        </p>
        <p className="copy__copy">
          That sounds very futuristic, but in Dubai they are already experimenting with flying
          motorbikes like you see in science-fiction movies. We’ll see how long it takes for the
          technology to go mainstream, but I’m sure that all the things we’ve discussed—low latency,
          AI, visual processing, autonomous navigation, edge computing power—will be essential to
          getting there.
        </p>
        <div className="copy__end" />
        <p className="copy__copy">
          For more information on innovative 5G and edge technology, visit{' '}
          <a
            className="copy--blue"
            href="https://www.supermicro.com/en/products/5g?utm_source=CNN+Boost+&utm_medium=Article+%231&utm_campaign=CNN+Boost+"
            target="_blank"
           rel="sponsored noopener"
          >
            5G Products
          </a>{' '}
          and{' '}
          <a
            className="copy--blue"
            href="https://www.supermicro.com/en/products/x12?utm_source=CNN+Boost+&utm_medium=Article+%231&utm_campaign=CNN+Boost+"
            target="_blank"
            rel="sponsored noopener"
          >
            X12 Products
          </a>
          .
        </p>
      </div>
      <div className="cta">
        <div className="cta__content cta--content1">
          <img src={cta1} className="cta__img" alt="" />
          <div className="cta__copy">
            <p className="cta__copy__text">
              The Data Center of the Future: Warmer, Denser, Modular and More Efficient
            </p>
            <button className="cta__copy__button">
              <a
                href="https://sponsorcontent.cnn.com/interactive/supermicro/datacenterofthefuture/"
                className="cta__link"
                target="_blank"
                rel="sponsored"
              >
                READ ARTICLE
              </a>
            </button>
          </div>
        </div>
        <div className="cta__content">
          <img src={cta3} className="cta__img" alt="" />
          <div className="cta__copy">
            <p className="cta__copy__text">
              7 Ways That 5G and Edge Computing Are Changing the World
            </p>
            <button className="cta__copy__button">
              <a
                href="https://sponsorcontent.cnn.com/interactive/supermicro/edgecomputing/"
                className="cta__link"
                target="_blank"
                rel="sponsored"
              >
                READ ARTICLE
              </a>
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
}

export default App;
